<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style src="./assets/css/style.css">

</style>



// WEBPACK FOOTER //
// src/App.vue